import React from 'react';
import { Redirect, Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { fetchPayerInfo, init, fetchOrder, fetchVipPaymentMethod } from '../../reducer/shop';
import { fetchVipInfo } from '../../reducer/vip';

// import { EXCHANGE_URL, PB_EXCHSNGE_GUIDE } from '../../constants';
import { DEFAULT_PAYMENT_METHOD } from '../../constants';

import StepZilla from 'react-stepzilla';
import './step.css';
import Pay from './pay';
import queryString from 'query-string';

function UnusedComp() {
    return <div></div>
}


/**
 * 取號資訊
 */
class PayInfo extends React.Component {
    constructor(props) {
        super(props);
        this.reset = this.reset.bind(this);
        // this.updateData = this.updateData.bind(this);
        // this.createOrder = this.createOrder.bind(this);
        this.close = this.close.bind(this);
    }
    
    reset(props) {
        const state = {
            autoTake: false,
            paymentMethod: DEFAULT_PAYMENT_METHOD,
            spec: 3,
            name: '',
            phone: '',
            gender: 'M',
            invType: 1,
            invTitle: '',
            invTaxNo: '',
            email: '',
            cityCode: '0001',
            townCode: '204',
            address: '',
            agree: false,
        }
        if (props.autoTake === true) {
            state.autoTake = true;
            ['name', 'phone', 'gender', 'email', 'cityCode', 'townCode', 'address'].forEach(key => {
                if (props[key]) {
                    state[key] = props[key];
                }
            });
        }
        this.setState(state);
    }

    componentDidMount() {
        let params = queryString.parse(this.props.location.search)
        const orderNo = params.orderNo;
        if (this.props.isLogin) {
            this.props.init();
            this.props.fetchVipPaymentMethod();
            this.props.fetchPayerInfo();
            this.props.fetchVipInfo();            

            this.props.fetchOrder({orderNo});

        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.loadingPayerInfo === false && this.props.loadingPayerInfo === true) {
            this.reset(nextProps);
        }
    }

    close() {
        this.props.init();
        this.props.fetchVipPaymentMethod();
        this.props.fetchPayerInfo();
        this.props.fetchVipInfo();
        this.props.history.push('/shop')
    }

    render() {
        if (!this.props.isLogin) {
            return <Redirect to={{ pathname: '/login', state: { from: '/shop' } }} />;
        }
        const { userInfo, loading, order, paymentMethods } = this.props;
        const steps = [
            { name: '選擇付款方式與金額', component: <UnusedComp /> },
            { name: '填寫個人資料', component: <UnusedComp /> },
            { name: '建立訂單', component: <UnusedComp /> },
            { name: '繳費', component: <Pay loading={loading} order={order} data={this.state} paymentMethods={paymentMethods} userInfo={userInfo} close={this.close} /> }
        ];
        return (
            <div className="container">
                <div className="page-header text-center">
                    <h1>VIP專屬儲值</h1>
                </div>
                <div className="row">
                    <div className="col-sm-offset-1 col-md-offset-1 col-md-10 col-sm-10 col-xs-12">
                        {
                            (!loading && userInfo.vipStatus === 0) &&
                            < div className="alert alert-danger">
                                <span className="glyphicon glyphicon-warning-sign"></span>
                                <span> 您尚未啟用VIP，請先<Link to="/vip">啟用VIP</Link>才能使用VIP專屬儲值喔</span>
                            </div>
                        }
                        <div className='step-progress'>
                            <StepZilla
                                startAtStep={3}
                                prevBtnOnLastStep={true}
                                showNavigation={false}
                                stepsNavigation={false}
                                steps={steps} />
                        </div>
                    </div>
                </div>
            </div >
        );
    }    
}


const mapStateToProps = state => ({
    ...state.shop,
    userInfo: state.vip,
    isLogin: state.user.isLogin
});

const mapDispatchToProps = dispatch => bindActionCreators({
    init,
    fetchPayerInfo,
    fetchVipInfo,
    fetchOrder,
    fetchVipPaymentMethod,
}, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PayInfo)


// WEBPACK FOOTER //
// ./src/containers/shop/payInfo.jsx